
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"2","height":"2","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1 .047a.85.85 0 01.648.266c.172.177.258.406.258.687s-.086.51-.258.688A.85.85 0 011 1.953a.875.875 0 01-.656-.266C.177 1.51.094 1.281.094 1S.177.49.344.312A.875.875 0 011 .047z","fill":"currentColor"}})])
          )
        }
      }
    